import { FlightsSortBy } from '@model/flights';
import { HYDRATE } from 'next-redux-wrapper';
import { isEqual } from 'lodash';
import { DealFinderResultsActions } from '@state/slices/deal-finder-results/dealFinderResultsSlice';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum FlightSortActions {
  NAME = '@FLIGHTS_SORT',
  SET_SORT = '@FLIGHTS_SORT/SET_SORT'
}

export const INITIAL_FLIGHTS_SORT_STATE: FlightsSortBy = FlightsSortBy.CHEAPEST;

const flightsSortSlice = createSlice({
  name: FlightSortActions.NAME,
  initialState: INITIAL_FLIGHTS_SORT_STATE,
  reducers: {
    setFlightsSort: (state, action: PayloadAction<FlightsSortBy.CHEAPEST>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(HYDRATE, (state: FlightsSortBy = INITIAL_FLIGHTS_SORT_STATE, action: any) => {
        if (isEqual(state, INITIAL_FLIGHTS_SORT_STATE)) {
          return action.payload.flightSort || state;
        }
        return state;
      })
      .addCase(DealFinderResultsActions.CLEAR_RESULTS, () => {
        return INITIAL_FLIGHTS_SORT_STATE;
      });
  }
});

export const { setFlightsSort } = flightsSortSlice.actions;
export const flightsSortReducer = flightsSortSlice.reducer;
